import React, { useMemo } from 'react';
import { TyCompanyLogoFromBucket } from '../../../../components/blob/CompanyLogoFromBucket';
import moment from 'moment';
import { AvIcon, CustomIcon, MapsIcon } from '@tymbe/ui-icons';
import { ShiftData } from '../../../../types/TymbeApi';

interface CompanyInfoProps {
  shift: ShiftData;
}

const CompanyInfo = ({ shift }: CompanyInfoProps) => {
  const startTime = useMemo(() => moment(shift.start_time), [shift.start_time]);
  const endTime = useMemo(() => moment(shift.end_time), [shift.end_time]);
  return (
    <div className="flex flex-col rounded-2xl bg-white shadow-down-xs p-4 gap-3">
      <div className="flex w-full gap-3">
        <TyCompanyLogoFromBucket
          src={shift.company?.logo}
          className="size-16 border border-secondary-200 rounded-lg"
        />
        <div className="flex flex-col flex-1">
          <div className="flex text-caption-xl font-medium text-secondary-400 justify-between">
            <span>
              {startTime.format('H:mm')}-{endTime.format('H:mm')}
            </span>
            <span>
            {endTime.diff(startTime, 'hours')}h
            </span>
          </div>
          <span className="text-body-2-xl font-semibold text-secondary-600">
            {shift.name}
          </span>
          <span className="text-caption-xl text-secondary-400">
            {shift.company?.name}
          </span>
          <span className="text-caption-xl text-secondary-400">
            {shift.branchoffice?.name}
          </span>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div className="grid grid-cols-2 items-center h-10 w-48 rounded-2xl border border-secondary-100 justify-center">
          <span className="flex justify-center text-secondary-600 text-body-2-xl font-semibold">
            {Number(shift.payment_base)} Kč/h
          </span>
          <div className="flex text-primary-400 h-full items-center justify-center text-caption-xl font-medium border-l border-secondary-100">
            <CustomIcon name="Coin" className="size-3" />
            {Number(shift.credits)} Kr/h
          </div>
        </div>
        <div className="flex gap-1">
          {!!shift.perk?.length && (
            <div className="size-fit rounded-full p-1 text-red-700 bg-red-100">
              <AvIcon name="playlist_add_check_circle" className="size-3" />
            </div>
          )}
          {Number(shift?.unfilled_orders_count) === 1 && (
            <div className="size-fit rounded-full p-1 text-orange-700 bg-orange-100">
              <MapsIcon name="local_fire_department" className="size-3" />
            </div>
          )}
          {!!shift.surcharges.length && (
            <div className="size-fit rounded-full p-1 text-blue-700 bg-blue-100">
              <CustomIcon name="Priplatky" className="size-3" />
            </div>
          )}
          {/* zachranarska smena, doplnit po zapojeni banovaciho flow
        <div className='size-fit rounded-full p-1 text-primary-700 bg-primary-100'>
          <FavouriteIcon name="favorite" className='size-3' />
        </div> */}
          {!!shift.shiftTemplate?.labels?.length && (
            <div className="size-fit rounded-full p-1 text-secondary-600 bg-secondary-100">
              <CustomIcon name="label2" className="size-3" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;
